export default __webpack_public_path__ + "static/media/Intelligence2.03c6ee2b.png";